export default __webpack_public_path__ + "static/media/filterIcon.c8b8b022.svg";